import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Headers, Http, RequestOptions } from '@angular/http';
import { isBrowser } from 'angular2-universal';
import { CookieService } from 'angular2-cookie/core';
import { ReplaySubject } from 'rxjs'; 
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';
import { ContentService } from '../shared/content.service';

@Injectable()
export class CartService {

    private headers = new Headers({ 'Content-Type': 'application/json' });
    private options = new RequestOptions({ headers: this.headers });
 
    // Items: [{content: recordObj, qty: 2}]
    items: any = [];
    // Cookie: {id: 12345, qty: 2}
    cookieData: Object = {};
    cookieOptions : Object = {};
    ready: boolean = false;
    // Display limit 
    limit: number = 3;
    // Id when payment has been processed
    paymentData = null;

    constructor(private config: ConfigService, private utils: UtilsService, private router: Router, private contentService: ContentService, private cookieService: CookieService, private http: Http) {
        // Retrieve unfinished purchase with cart in cookie
        if(isBrowser){
            this.getCookieItems();
        }
    }

    setCookieExpiresInDays(days){
        this.cookieOptions['expires'] = this.utils.dateNowPlusDays(days)
    }

    getCookieItems(){
        let cookie = this.cookieService.getObject('cart');
        if(cookie && Object.keys(cookie).length>0) {
            this.cookieData = this.cookieService.getObject('cart');
            let idsString = Object.keys(this.cookieData).join(',');
            this.contentService.findContents('record',idsString).then(contents => {
                for(let content of contents){
                    if(content!=null){
                        this.items.push({
                            content: content, 
                            qty: this.cookieData[content._id]
                        });
                    }

                }
            });
        } 
    }

    isInCart(id: string) {
        for(let added of this.items){
            if(id==added['content']._id){
                return true;
            }
        }
        return false;
    }

    update(content: Object, qty: number){
        // see if record is already in cart
        let exists: boolean = false;
        for(let added of this.items){
            if(content['_id']==added['content']._id){
                added['qty'] = qty; // update quantity
                exists =  true;
                // cookie
                this.cookieData[added['content']._id] = added['qty'];
                this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
            }
        }
        // new item in cart
        if(!exists){
            this.items.push({
                content: content,
                qty: qty
            });
            // cookie
            this.cookieData[content['_id']] = qty;
            this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
        }
    }

    remove(id: string){
        let newItems: Object[] = [];
        for(let added of this.items){
            if(id!=added.content._id)
                newItems.push(added);
        }
        // cookie
        delete this.cookieData[id]
        this.cookieService.putObject('cart', this.cookieData, this.cookieOptions);
        this.items = newItems;
    }

    clear(){
        this.items = [];
        this.cookieService.remove('cart');
        // Clear payment data when navigating away from cart
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.paymentData = null;
            }
        });
    }

    shipping(): number {
        let nb:number = this.countAll(); 
        let cost:number = 0;
        if(nb>0)
            cost = this.config.data.CART.SHIPPING_FIRST;
        if(nb>1)
            cost += this.config.data.CART.SHIPPING_OTHER * (nb-1);
        return Number.parseFloat(cost.toFixed(2));
    }

    subtotal(): number {
        let total:number = 0;
        for(let added of this.items){
            total += added.qty * added.content.price;
        }
        return Number.parseFloat(total.toFixed(2));
    } 

    total(): number {
        // Issue with decimals
        let total = this.subtotal() + this.shipping();
        //console.log(Number.parseFloat(total.toFixed(2)));
        //return Number.parseFloat(total.toFixed(2));
        return Number.parseFloat(total.toFixed(2));
    }

    count(){
        return this.items.length;
    }

    countAll(){
        let count:number = 0;
        for(let added of this.items)
            count += +added.qty;
        return count;
    }

    itemsLimited(): any[] {
        let limited = [];
        for (var i = this.items.length-1; i >=0; i--) {
            limited.push(this.items[i]);
            if(limited.length>=this.limit)
                break;
        }
        return limited;
    }

    checkout(data: any): Promise<any> {
        return this.http.post('/api/payment/checkout', data, this.options)
            .toPromise()
            .then(response => {
                //console.log(response.json()); 
                return response
            })
            .catch(this.handleError);
    }
    getClientToken(): Promise<any> {
        return this.http.get('/api/payment/token')
            .toPromise()
            .then(response => {
                return response;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('Content API error', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cart.service.ts